import React from "react";
import * as Yup from "yup";

import { Box, Text, Button, Flex, Modal } from "atoms";
import MemoClose from "assets/icons/Close";
import { Form, Formik } from "formik";
import { FormInput } from "molecules/FormInput";

export const ConfirmationModal = ({
  onClose,
  icon: { Icon, IconProps, ICprops } = {},
  textOne,
  textTwo,
  textThree,
  textFour,
  onConfirm,
  isComment,
}) => {
  return (
    <Modal isOpen onClose={onClose}>
      <Box maxWidth="48.8rem">
        <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
          <Flex
            justifyContent="space-between"
            borderBottom="0.1rem solid"
            borderColor="neutral.100"
            pb="2.4rem"
          >
            <Text fontSize="2rem" color="primary.900" fontFamily="primaryBold">
              Are you sure?
            </Text>
            <Box
              color="neutral.900"
              onClick={onClose}
              cursor="pointer"
              textAlign="right"
            >
              <MemoClose height="1.6rem" width="1.6rem" />
            </Box>
          </Flex>

          {Icon && (
            <Box mt="2.7rem" textAlign="center" {...ICprops}>
              <Icon height="3.4rem" width="3.4rem" {...IconProps} />
            </Box>
          )}
          {/* {isPublish && (
            <Box color="secondary.500" mt="2.7rem" textAlign="center">
              <MemoCircleMinusIcon height="3.4rem" width="3.4rem" />
            </Box>
          )}

          {isUnPublish && (
            <Box color="primary.900" mt="2.7rem" textAlign="center">
              <MemoCircleCheckIcon height="3.4rem" width="3.4rem" />
            </Box>
          )}

          {isDelete && (
            <Box color="accents.100" mt="2.7rem" textAlign="center">
              <MemoDeleteIcon height="3.4rem" width="3.4rem" />
            </Box>
          )} */}

          <Text
            mt="2.7rem"
            color="neutral.800"
            textAlign="center"
            fontSize="1.6rem"
            fontFamily="NeometricRegular"
          >
            {textOne}{" "}
            {textTwo && (
              <Text as="span" fontSize="1.6rem" fontFamily="primaryBold">
                {textTwo}
              </Text>
            )}{" "}
            {textThree && (
              <Text as="span" fontSize="1.6rem" fontFamily="NeometricRegular">
                {textThree} {textFour || ""}
              </Text>
            )}
          </Text>

          {isComment && (
            <>
              <Formik
                initialValues={{ comments: "" }}
                validationSchema={Yup.object().shape({
                  comments: Yup.string().required("Comments are required"),
                })}
                onSubmit={onConfirm || (() => {})}
                enableReinitialize
              >
                {() => {
                  return (
                    <Form>
                      <Box mt="2.4rem">
                        <FormInput
                          name="comments"
                          type="textarea"
                          minHeight="14.4rem"
                          placeholder="Enter Comments"
                          req
                          removeValidationIcon
                        />
                      </Box>
                      <Flex
                        mt="3.2rem"
                        gridGap="2.4rem"
                        justifyContent="space-between"
                        // flexDirection={isDelete ? "row-reverse" : "inherit"}
                      >
                        <Button
                          variant="secondary"
                          type="button"
                          onClick={onClose}
                          height={{ xs: "4.3rem", lg: "4.8rem" }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="primary"
                          type="submit"
                          height={{ xs: "4.3rem", lg: "4.8rem" }}
                        >
                          Confirm
                        </Button>
                      </Flex>
                    </Form>
                  );
                }}
              </Formik>
            </>
          )}

          {!isComment && (
            <Flex
              mt="2.4rem"
              gridGap="2.4rem"
              justifyContent="space-between"
              // flexDirection={isDelete ? "row-reverse" : "inherit"}
            >
              <Button
                variant="secondary"
                onClick={onClose}
                height={{ xs: "4.3rem", lg: "4.8rem" }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                height={{ xs: "4.3rem", lg: "4.8rem" }}
                onClick={onConfirm}
              >
                Confirm
              </Button>
            </Flex>
          )}
        </Box>
      </Box>
    </Modal>
  );
};
